// src/components/About.js
import React, { useEffect, useState } from 'react';
import homeLoan from "../../images/Homepage/HomeLoan.png";
import zeroInt from "../../images/Homepage/Zero.png";
import regist from "../../images/Homepage/Legal.png";
import inspection from "../../images/Homepage/Inspection.png";
import { Link } from 'react-router-dom';
import { eventEmitter } from '../EventEmitter';
import axios from 'axios';
import ConfirmationModal from '../modals/ConfirmationModal';

const OfferedFacilities = ({user,token}) => {
    const [enquiredCategories, setEnquiredCategories] = useState({});
    const [showModal, setShowModal] = useState(false);
      const [msgTitle, setMsgTitle] = useState("");
      const [message, setMessage] = useState("");
      const [icon, setIcon] = useState("");
      const [theme, setTheme] = useState("");
      const offered = {
        home_loan: {
          title: 'Home Loan',
          message: 'Thank you for your interest! Our finance team will contact you soon regarding home loan options.'
        },
        rentals: {
          title: 'Zero Brokerage Rentals',
          message: 'Thank you! Our rentals team will connect with you shortly to assist with your property needs.'
        },
        legal_registration: {
          title: 'Legal & Registration',
          message: 'Thank you for reaching out! Our legal experts will assist you with registration and documentation soon.'
        },
        property_inspection: {
          title: 'Property Inspection',
          message: 'Thank you! Our inspection team will coordinate with you shortly to schedule a property visit.'
        }
      };
      
     const handleShowModal = (category) => {
            if (!user?.data?.id) {
                eventEmitter.emit('loginFirst', true);
                return
            }
           
            createEnquiry(category);
        };

        const createEnquiry = async (category) => {


            try {
                //alert(property.property_ids)
                const formData = new FormData();
                formData.append('user_id', user?.data?.id);
                formData.append('name', user?.data?.name);
                formData.append('email', user?.data?.email);
                formData.append('mobile', user?.data?.mobile);
                formData.append('category', category);
                const response = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/createEnquiry`, // Replace with your API URL
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`, // Attach Bearer token
                            'Content-Type': 'application/json', // Set correct content type for file upload
                        },
                    }
                );
    
                if (response.status) {
                    setEnquiredCategories(prev => ({ ...prev, [category]: true })); // Mark category as enquired
                    const offeredList = offered[category]  
                    setShowModal(true)
                    setMsgTitle(offeredList.title)
                    setMessage(offeredList.message)
                    setIcon('fa fa-check-circle-o')
                    setTheme('green')
    
                }
    
    
    
            } catch (error) {
                console.error('Error updating:', error);
                if (error.response.status === 409) {
                  setShowModal(true)
                  setMsgTitle('You have already submitted an enquiry today.')
                  setMessage()
                  setIcon('fa fa-info-circle')
                  setTheme('gold')
                }else{
                  setShowModal(true)
                  setMsgTitle('Something Went Wrong. Please try again.')
                  setMessage()
                  setIcon('fa fa-times-circle-o')
                  setTheme('red')
                }
                // if (error.response?.status === 409) {
                //     setEnquiredCategories(prev => ({ ...prev, [category]: true })); // Mark category as enquired
                //     alert(error.response?.message ?? 'You have already submitted an enquiry today.');
                    
                // } else {
                //     alert('Something Went Wrong. Please try again.');
                // }
            }
        };

  
  return (
    <section className="facility-section sectiontopgap">
    <div className="container">

      <div className="sectiontitle">
        <div className="titleunderline" data-aos='fade-right'>
          <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
          </svg>
        </div>
        <h1>Offered Facilities</h1>
      </div>

      <div className='facilities' style={{ marginTop: '80px' }}>
        <div className='faci_row'>
          <div className='faci_col'>
            <div className='cardbase'>
              <div className='ofaciicon'>
                <img src={homeLoan} className='faci_img' />
              </div>
              <div className='cardcont'>
                <div className='faci_title'>
                  <h3>Home Loan</h3>
                </div>
                <div className='faci_points'>


                  <p>Attractive Interest Rates</p>
                  <p>Greater Loan Eligibility</p>
                  <p>Loan Offers From Banks</p>

                </div>

              </div>
              <div className='cardbtn'>
               
                  <button className="btn faci_button" disabled={enquiredCategories['home_loan']} type="button" onClick={()=>handleShowModal('home_loan')}>
                    <span>{enquiredCategories['home_loan'] ? 'Applied' : 'Apply Now'}</span>
                  </button>
             
              </div>
            </div>
          </div>
          <div className='faci_col'>
            <div className='cardbase'>
              <div className='ofaciicon'>
                <img src={zeroInt} className='faci_img' />
              </div>
              <div className='cardcont'>
                <div className='faci_title'>
                  <h3>Zero Brokerage <br />Rentals</h3>
                </div>
                <div className='faci_points'>


                  <p>Hassel Free Property</p>
                  <p>Management Services.</p>

                </div>

              </div>
              <div className='cardbtn'>
               
                  <button className="btn faci_button" type="button" disabled={enquiredCategories['rentals']} onClick={()=>handleShowModal('rentals')}>
                  <span>{enquiredCategories['rentals'] ? 'Contacted' : 'Contact Now'}</span>
                  </button>
               
              </div>
            </div>
          </div>
          <div className='faci_col'>
            <div className='cardbase'>
              <div className='ofaciicon'>
                <img src={regist} className='faci_img' />
              </div>
              <div className='cardcont'>
                <div className='faci_title'>
                  <h3>Legal & Registration</h3>
                </div>
                <div className='faci_points'>

                  <p>End To End Legal  </p>
                  <p>Assistance in Property</p>
                  <p>Related Matters.</p>

                </div>

              </div>
              <div className='cardbtn'>
                  <button className="btn faci_button" type="button"  disabled={enquiredCategories['legal_registration']}onClick={()=>handleShowModal('legal_registration')}>
                  <span>{enquiredCategories['legal_registration'] ? 'Contacted' : 'Contact Now'}</span>
                  </button>
              </div>
            </div>
          </div>
          <div className='faci_col'>
            <div className='cardbase'>
              <div className='ofaciicon'>
                <img src={inspection} className='faci_img' />
              </div>
              <div className='cardcont'>
                <div className='faci_title'>
                  <h3>Property Inspection</h3>
                </div>
                <div className='faci_points'>



                  <p>Get Your Property </p>
                  <p> Evaluated Inside-Out By</p>
                  <p>Professionals/Experts.</p>

                </div>

              </div>
              <div className='cardbtn'>
                  <button className="btn faci_button"disabled={enquiredCategories['property_inspection']} type="button" onClick={()=>handleShowModal('property_inspection')}>
                  <span>{enquiredCategories['property_inspection'] ? 'Contacted' : 'Contact Now'}</span>
                  </button>
              </div>
            </div>
          </div>



        </div>
      </div>

    </div>
    {showModal && (
          <ConfirmationModal
            onClose={() => setShowModal(false)}
            title={msgTitle}
            message={message}
            icon={icon}
            theme={theme}
          />
        )}
  </section>
  );
};

export default OfferedFacilities;
